
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cagri-aydinlatma",
      function () {
        return require("private-next-pages/cagri-aydinlatma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cagri-aydinlatma"])
      });
    }
  